<template>
  <div>
    <b-container class="bv-example-row">
      <b-row class="bg-dark text-white">
        <b-col sm="6" class=" p-3 text-left">
          <b-row align-h="start">
            <b-col>
              <h5>
                Ayo tes keceptan jarimu jadilah yang tertinggi di ladderboard,
                Telah terdaftar lebih dari 100+ orang yang memulai tes ini dan
                kamu bisa menjadi salah satunya.
              </h5>
            </b-col>
          </b-row >
          <b-row align-h="center">
            <b-col cols="4">
              <b-button pill>Login</b-button>
            </b-col>
            <b-col cols="4">
              <b-button pill variant="primary">SignUp </b-button>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="3" class=" p-3  text-left">
          <h5>Seberapa Cepat</h5>
          <p class="text">
            Merupakan suatu website yang dapat digunakan untuk mengukur
            kecepatan jari dalam mengetik, menekan tombol keyboard, dan menekan
            mouse
          </p>
        </b-col>
        <b-col sm="3" class=" p-3  text-left">
          <h5>Kontak Pengembang</h5>
          <b-row>
            <b-col cols="2">
              <img
                src="../assets/facebook.png"
                width="32"
                height="32"
                class="d-inline-block align-top"
                alt="logo"
              />
            </b-col>
            <b-col>
              <div class="justify-content-center">
                <p>ivan panska</p>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2">
              <img
                src="../assets/intagram.png"
                width="32"
                height="32"
                class="d-inline-block align-top"
                alt="logo"
              />
            </b-col>
            <b-col>
              <div class="justify-content-center">
                <p>ivan_fabriano</p>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2">
              <img
                src="../assets/twitter.png"
                width="32"
                height="32"
                class="d-inline-block align-top"
                alt="logo"
              />
            </b-col>
            <b-col>
              <div class="justify-content-center">
                <p>ivan_fabriano</p>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {};
</script>
<style></style>
